import { motion } from 'framer-motion'
import { useInView } from './useInView'
import { ArrowUpRight } from 'lucide-react'
import { useT } from '../i18n/LanguageContext'

export default function CTA() {
  const t = useT()
  const { ref, isInView } = useInView()

  return (
    <section className="relative pt-8 pb-24 min-h-[88vh] flex flex-col justify-center overflow-hidden bg-white/[0.012]">
      <div className="absolute inset-0 bg-radial-top" />

      <div ref={ref} className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
        >
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light text-white tracking-tight mb-6">
            {t.cta.titlePart1}{' '}
            <span className="text-gradient-warm">{t.cta.titlePart2}</span>
          </h2>
          <p className="text-lg text-zinc-400 max-w-2xl mx-auto leading-relaxed mb-12">
            {t.cta.subtitle}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="mailto:hello@solidlabs.site"
              className="group inline-flex items-center gap-2 px-7 py-3.5 bg-brand-700 hover:bg-brand-600 text-white font-medium rounded-lg border border-white/[0.08] hover:border-white/[0.14] transition-all"
            >
              {t.cta.ctaPrimary}
              <ArrowUpRight
                size={18}
                className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
              />
            </a>
            <a
              href="https://spotto.pl"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-white/[0.06] hover:bg-white/[0.1] text-zinc-300 hover:text-white border border-white/[0.1] hover:border-white/[0.16] font-medium rounded-lg transition-all"
            >
              {t.cta.ctaSecondary}
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
